import styled from "styled-components";

export const Scroller = styled.div<{ $height: string }>`
  height: ${({ $height }) => $height};
  overflow: auto;
  position: relative;
`;

export const Spacer = styled.div<{ $size: number }>`
  position: relative;
  width: 100%;
  height: ${({ $size }) => $size}px;
`;

export const Row = styled.div<{ $start: number; $size: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ $size }) => $size}px;
  transform: translateY(${({ $start }) => $start}px);
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Head = styled.thead`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${({ theme }) => theme.colors.surface.primary};
`;

export const PadRow = styled.tr<{ $size: number }>`
  height: ${({ $size }) => $size}px;
`;
